module.exports = __webpack_public_path__ + "img/branner.d010b88.jpg";